import API from "libs/api";
import { createBaseInstance } from "libs/request";
// @ts-ignore
import config from "config/index";

class UserAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(
      `${config.api.mts}Me`,
      createBaseInstance
    );
  }

  getProfile = () => this.instance.get('/Profile');

  updateUser = (payload) => this.instance.put(`/Profile`, payload);

  verify = (id, payload) => this.instance.post(`/verify/${id}`, payload);

  changePassword = (payload) => this.instance.put('/ChangePassword', payload);

  getClients = (params = {}) => this.instance.get(`/Clients`, {
    params
  });

  getTenants = (params = {}) => this.instance.get(`/Tenants`, {
    params
  });
}

export default UserAPI;
